// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalUpdate_root__1O8xK","footer":"ModalUpdate_footer__1MLim"};